import { __decorate, __metadata } from "tslib";
import { SerializableObject, SerializableArrayMember } from '@openhps/core';
import { tree } from '../../terms';
import { SerializableThing } from '@openhps/rdf';
let Collection = class Collection extends SerializableThing {
    constructor() {
        super(...arguments);
        this.members = [];
    }
};
__decorate([
    SerializableArrayMember(SerializableThing, {
        rdf: {
            predicate: tree.member,
            serializer: false,
        },
    }),
    __metadata("design:type", Array)
], Collection.prototype, "members", void 0);
Collection = __decorate([
    SerializableObject({
        rdf: {
            type: tree.Collection,
        },
    })
], Collection);
export { Collection };
//# sourceMappingURL=Collection.js.map